import {Component, Inject} from '@angular/core';
import {SSOService} from "../../../services/sso/SSOService";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {
  MatCard,
  MatCardContent,
  MatCardFooter,
  MatCardHeader,
  MatCardSubtitle,
  MatCardTitle
} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {MatButtonLoading} from "@ng-matero/extensions/button";
import {SessionManager} from "../../../manager/SessionManager";

@Component({
  selector: 'app-register-confirm',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatCard,
    MatCardContent,
    MatCardFooter,
    MatCardHeader,
    MatCardTitle,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatButtonLoading,
    MatCardSubtitle
  ],
  templateUrl: './register-confirm.component.html',
  styleUrl: './register-confirm.component.css',
  providers: [SSOService,SessionManager]
})
export class RegisterConfirmComponent {

  form: FormGroup
  isSubmitting = false;

  constructor(
    private dialogRef: MatDialogRef<RegisterConfirmComponent>,
    private ssoService: SSOService,
    private toast: ToastrService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) private params: any) {
    this.form = new FormGroup(
      {
        "code": new FormControl("", [Validators.required, Validators.min(6)]),
      }
    );
  }


  close() {
    this.dialogRef.close()
  }

  save() {
    if (this.form.valid) {
      this.isSubmitting = true
      let email = this.params.email
      this.ssoService.registerEmailConfirm(email, this.form.controls.code.value)
        .subscribe(response => {
          this.close()
          this.isSubmitting = false
          this.toast.success("Готово")
          this.router.navigateByUrl("/auth/login")

        },e => {
          this.isSubmitting = false
        })
    }
  }

}
